import React from 'react';
import './style.scss';

export const GenericTextInput = ({
  onChange,
  caption,
  value,
  name,
  classNames = [''],
  textInputProps = {},
  styles = {},
}) => {
  const handleChange = e => {
    e.persist();
    onChange(e);
  };

  return (
    <div className="cv-generic-text-input">
      {caption && (
        <label
          className={'cv-generic-text-input__label'}
          htmlFor={textInputProps?.id ? textInputProps?.id : caption}
        >
          {caption}
        </label>
      )}
      <input
        autoComplete="off"
        type="text"
        className={`${['cv-generic-text-input__input', ...classNames].join(
          ' ',
        )}`}
        style={styles}
        onChange={handleChange}
        name={name}
        value={value}
        id={textInputProps?.id ? textInputProps?.id : caption}
        {...textInputProps}
      />
    </div>
  );
};
